<template>
  <div class="cml-input-maxlength">
    <el-divider class="cml-divider" id="cml-divider" content-position="center"
      >{{ statusName }}单个ODM样品</el-divider
    >
    <el-form
      :disabled="formDisabled"
      :model="formData"
      :rules="rules"
      ref="formData"
      label-width="300px"
    >
      <el-form-item label="供应商" prop="supplierName">
        <el-input v-if="!['2', '1'].includes(this.$store.getters.userSelf.user.adminType) || status !== 'add'" disabled v-model.trim="formData.supplierName" />
        <!-- <el-input v-model="formData.supplierName" disabled></el-input> -->
        <SupplierSelect
          v-else
          :disabled="
            !['2', '1'].includes(this.$store.getters.userSelf.user.adminType) ||
            status !== 'add'
          "
          supplierType="ODM"
          :value="formData.supplierCode"
          @change-emit="supplierChange"
        />
      </el-form-item>
      <el-form-item label="产品名称" prop="productName">
        <el-input
          v-model.trim="formData.productName"
          :maxlength="maxlength"
          show-word-limit
        ></el-input>
        <span style="color: #AB0033; font-size: 12px; margin-left: 10px">
          供应商简称+配方名称+核心+功效 （如 XX 2023年新品超细颗料乳化面霜超强抗氧化）
        </span>
      </el-form-item>
      <el-form-item label="产品类别" prop="productType">
        <DictSelect
          type="odm_product_type"
          :value="formData.productType"
          @change-emit="productTypeChange"
        />
      </el-form-item>
      <el-form-item id="img-box" label="产品品类" prop="productCategory">
        <el-select
          v-model="formData.productCategory"
          filterable
          clearable
          size="mini"
        >
          <el-option
            v-for="item in odmProductCategoryCmdss"
            :key="item.id"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="odmProductEfficacyCmdsShow"
        label="产品功效"
        prop="odmProductEfficacyCmds"
      >
        <el-checkbox-group
          v-model="formData.odmProductEfficacyCmds"
          style="width: 480px"
        >
          <el-checkbox
            v-for="(item, index) in odmProductEfficacyCmdss"
            :key="index"
            :label="item.value"
            name="type"
            >{{ item.label }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
      <el-form-item
        class="odmSuitableSkinCmdsClass"
        label="适合肤质"
        prop="odmSuitableSkinCmds"
      >
        <el-checkbox-group
          v-model="formData.odmSuitableSkinCmds"
          style="width: 480px"
        >
          <el-checkbox
            v-for="(item, index) in odmSuitableSkinCmdss"
            :key="index"
            :label="item.value"
            name="type"
            >{{ item.label }}</el-checkbox
          >
        </el-checkbox-group>
        <div class="text-tips">
          <p>
            举例1：A产品适合所有肤质，尤其适合干性肤质。那么此处请勾选“所有肤质”和“干性”
          </p>
          <p>
            举例2：B产品适合干性和敏感性肤质。那么此处请勾选“干性”和“敏感性”
          </p>
          <p>举例3：C产品适合所有肤质，那么此处只勾选“所有肤质”一个选项</p>
        </div>
      </el-form-item>
      <el-form-item id="img-box2" label="产品主打功效" prop="mainEfficacye">
        <el-input
          style="width: 420px"
          type="textarea"
          v-model="formData.mainEfficacye"
          maxlength="300"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="产品核心宣称或背书" prop="endorsement">
        <el-input
          style="width: 420px"
          type="textarea"
          v-model="formData.endorsement"
          maxlength="300"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="主图片" class="img-box" required prop="mainImage">
        <UploadImage
          v-if="showUploadImage"
          ref="uploadImage"
          :disabled="formDisabled"
          :status="status"
          :imgUrl="formData.mainImage"
          @img-change="mainImageChange"
        />
        <!-- <span class="example-img">
          <span>
            <b>图片示例</b><br />
            <i>注意事项：<br />1、请拍清晰</i>
          </span>
          <img src="@/assets/images/odm.png" />
        </span> -->
      </el-form-item>
      <el-form-item label="是否有专利" prop="havePatent">
        <DictSelect
          type="cml_common_whether"
          :value="formData.havePatent"
          @change-emit="value => (formData.havePatent = value)"
        />
      </el-form-item>
      <el-form-item label="预估含税单价（元/kg）" prop="price">
        <CustomNumInput
          :value="formData.price"
          :maxlength="7"
          :isNegativeFloat="true"
          @change-emit="val => (formData.price = val)"
        />
      </el-form-item>
      <el-form-item label="生产周期（天）" prop="productionCycle">
        <CustomNumInput
          :value="formData.productionCycle"
          :maxlength="7"
          :limitNum="0"
          @change-emit="val => (formData.productionCycle = val)"
        />
      </el-form-item>
      <el-form-item label="是否做过大货生产" prop="haveMassProduction">
        <DictSelect
          type="cml_common_whether"
          :value="formData.haveMassProduction"
          @change-emit="haveMassProductionChange"
        />
      </el-form-item>
      <el-form-item v-if="formData.haveMassProduction === 'YES'" label="已使用品牌" prop="brandsUsed">
        <el-input
          v-model.trim="formData.brandsUsed"
          :maxlength="maxlength"
          show-word-limit
          placeholder="多个品牌请用逗号隔开"
        ></el-input>
      </el-form-item>
      <el-form-item
        v-if="formData.haveMassProduction === 'NO'"
        label="开发进度"
        prop="developmentProgress"
      >
        <el-input
          v-model.trim="formData.developmentProgress"
          :maxlength="maxlength"
          show-word-limit
          placeholder="请说明开发进度"
        ></el-input>
      </el-form-item>
      <el-form-item label="样品的发货时间" prop="deliveryTime">
        <CustomNumInput
          :value="formData.deliveryTime"
          :maxlength="7"
          :limitNum="0"
          @change-emit="val => (formData.deliveryTime = val)"
        />
        天内
      </el-form-item>
      <el-form-item label="是否被水羊启用过" prop="shuiyangEnable">
        <DictSelect
          type="cml_common_whether"
          :value="formData.shuiyangEnable"
          @change-emit="value => (formData.shuiyangEnable = value)"
        />
      </el-form-item>
      <el-form-item label="产品详情" id="editor-box" prop="information">
        <TextareaEditor :disabled="formDisabled" ref="textareaEditor" />
      </el-form-item>
    </el-form>

    <span
      v-if="!formDisabled && status !== 'verify'"
      style="margin: 20px 0 50px 300px"
    >
      <el-button size="medium" :loading="saveLoading" @click="saveBtn"
        >保存草稿</el-button
      >
      <el-button
        type="primary"
        size="medium"
        style="margin-left: 50px"
        :loading="saveLoading"
        @click="submitBtn"
        >提交审核</el-button
      >
    </span>

    <SubmitDialog
      :dialogVisible="dialogVisible"
      @create-again="createAgain"
      @to-sample-page="toSamplePage"
    />

    <!-- 审核 -->
    <VerifyComponent
      ref="verifyComponent"
      :status="status"
      :statusName="statusName"
      :saveLoading="saveLoading"
      @verify-btn="verifyBtn"
    />
  </div>
</template>
<script>
import SupplierSelect from '@/components/SupplierSelect';
import DictSelect from '@/components/DictSelect';
import UploadImage from '@/components/Upload/UploadImage.vue';
import CustomNumInput from '@/components/CustomNumInput';
import TextareaEditor from '@/components/TextareaEditor';
import VerifyComponent from '../sample-component/VerifyComponent.vue';
import SubmitDialog from '../sample-component/SubmitDialog.vue';
import { odmProductCategoryCmdsData } from '@/utils/pageInfo';
import sampleCreate from '@/mixins/sampleCreate';

export default {
  name: 'publish-ODM-sample',
  components: {
    SupplierSelect,
    DictSelect,
    UploadImage,
    CustomNumInput,
    TextareaEditor,
    VerifyComponent,
    SubmitDialog,
  },
  mixins: [sampleCreate],
  data() {
    const mainImageValid = (rule, value, callback) => {
      if (!value) {
        this.pageScrollToTop('img-box2');
        callback(new Error('请选择主图片'));
      } else {
        callback();
      }
    };
    return {
      id: '',
      row: { id: '' },
      formData: {
        sampleId: '',
        id: '',
        supplierCode: '',
        supplierName: '',
        productName: '',
        productType: '',
        productCategory: '',
        odmProductEfficacyCmds: [],
        odmSuitableSkinCmds: [],
        mainEfficacye: '',
        endorsement: '',
        mainImage: '',
        havePatent: '',
        price: '',
        productionCycle: '',
        minNum: '',
        haveMassProduction: '',
        developmentProgress: '',
        brandsUsed: '',
        deliveryTime: '',
        shuiyangEnable: '',
        information: '',
      },
      odmProductCategoryCmdss: [],
      odmProductEfficacyCmdss: [],
      odmSuitableSkinCmdss: [],
      formDisabled: false,
      rules: {
        productName: [
          { required: true, message: '请输入产品名称', trigger: 'blur' },
        ],
        productType: [
          { required: true, message: '请选择产品类别', trigger: 'change' },
        ],
        productCategory: [
          { required: true, message: '请选择产品品类', trigger: 'change' },
        ],
        odmProductEfficacyCmds: [
          { required: true, message: '请选择产品功效', trigger: 'change' },
        ],
        odmSuitableSkinCmds: [
          { required: true, message: '请选择适合肤质', trigger: 'change' },
        ],
        mainEfficacye: [
          { required: true, message: '请输入产品主打功效', trigger: 'blur' },
        ],
        mainImage: [{ validator: mainImageValid, trigger: 'blur' }],
        endorsement: [
          {
            required: true,
            message: '请输入产品核心宣称或背书',
            trigger: 'blur',
          },
        ],
        havePatent: [
          { required: true, message: '请选择是否有专利', trigger: 'change' },
        ],
        price: [
          { required: true, message: '请输入预估含税单价', trigger: 'blur' },
        ],
        productionCycle: [
          { required: true, message: '请输入生产周期', trigger: 'blur' },
        ],
        haveMassProduction: [
          {
            required: true,
            message: '请选择是否做过大货生产',
            trigger: 'change',
          },
        ],
        deliveryTime: [
          { required: true, message: '请输入样品的发货时间', trigger: 'blur' },
        ],
        shuiyangEnable: [
          {
            required: true,
            message: '请选择是否被水羊启用过',
            trigger: 'change',
          },
        ],
      },
      saveLoading: false,
      dialogVisible: false,
      status: 'add',
      statusName: '新增',
      maxlength: 30,
      odmProductEfficacyCmdsShow: true,
      showUploadImage: true,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.checkQueryParams(vm);
    });
  },
  mounted() {
    const { code, name } = this.$store.getters.userSupplier;
    if (code) {
      this.formData.supplierCode = code;
      this.formData.supplierName = name;
    }
    const {
      odm_suitable_skin,
      odm_product_efficacy,
    } = this.$store.getters.allDictListData.data;
    this.odmSuitableSkinCmdss = odm_suitable_skin;
    this.odmProductEfficacyCmdss = odm_product_efficacy;
  },
  methods: {
    getDetail() {
      this.$http.sampleManage
        .getODMSample(this.id)
        .then(result => {
          for (let i in this.formData) {
            this.formData[i] = result.data[i];
          }
          this.formData.sampleId = this.row.id;
          // 产品类别
          this.productTypeChange(result.data.productType);
          this.formData.productCategory = result.data.productCategory;
          // 产品功效
          this.formData.odmProductEfficacyCmds = result.data.odmProductEfficacyVOList.map(
            item => item.productEfficacy,
          );
          // 适合肤质
          this.formData.odmSuitableSkinCmds = result.data.odmSuitableSkinVOList.map(
            item => item.suitableSkin,
          );
          // 设置textarea内容
          this.$refs.textareaEditor.setHtml(result.data.information);
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },
    exportOdmFunc(arr, type) {
      const data = this.$store.getters.allDictListData.data[type];
      const list = data.filter(item => arr.some(el => el === item.label));
      return list;
    },
    productTypeChange(val) {
      // 如果产品类别选择“彩妆”，那么“产品品类”的可选项是“卸妆， 口红/唇釉，粉底气垫，隔离，眼影眼线，眉笔眉粉，修容腮红，睫毛膏，化妆工具、其它“；并且不显示“产品功效”栏目。
      // 如果产品类别选择“护肤”，那么“产品品类”的可选项是“面膜(贴片和涂抹)，洁面，男士洁面，化妆水，乳液面霜，精华，眼霜，润唇膏，防晒，鼻贴/祛痘贴，T区护理，面部喷雾、其它 ”；并显示“产品功效”栏目，产品功效的可选项为“清洁控油，保湿补水，美白提亮，淡斑，淡化细纹，抗皱/抗衰/紧致， 收缩毛孔，去黑眼圈，舒敏修护，祛痘消炎，盈润透亮，增加皮肤弹性，抗污染/抗蓝光，抗氧化/抗糖化、其它”
      // 如果产品类别选择“美容美体”，那么“产品品类”的可选项是“身体乳，香水，手霜手膜足膜，美容仪，美甲、其它”；并且不显示“产品功效”栏目。
      this.formData.productType = val;
      this.formData.productCategory = '';
      this.formData.odmProductEfficacyCmds = [];
      if (val === 'COSMETIC') {
        this.odmProductEfficacyCmdsShow = false;
        this.formData.odmProductEfficacyCmds = [];
        this.odmProductCategoryCmdss = this.exportOdmFunc(
          odmProductCategoryCmdsData.COSMETIC,
          'odm_product_category',
        );
      } else if (val === 'SKIN_CARE') {
        this.odmProductEfficacyCmdsShow = true;
        this.odmProductCategoryCmdss = this.exportOdmFunc(
          odmProductCategoryCmdsData.SKIN_CARE,
          'odm_product_category',
        );
        this.odmProductEfficacyCmdss = this.exportOdmFunc(
          odmProductCategoryCmdsData.odmProductEfficacyCmdsData,
          'odm_product_efficacy',
        );
      } else if (val === 'COSMETOLOGY') {
        this.odmProductEfficacyCmdsShow = false;
        this.formData.odmProductEfficacyCmds = [];
        this.odmProductCategoryCmdss = this.exportOdmFunc(
          odmProductCategoryCmdsData.COSMETOLOGY,
          'odm_product_category',
        );
      }
    },
    haveMassProductionChange(val) {
      this.formData.haveMassProduction = val;
      this.formData.brandsUsed = '';
      this.formData.developmentProgress = '';
    },
    checkParams() {
      let state = true;
      if (this.formData.productionCycle === '0') {
        this.$message.error('生产周期必须大于0');
        state = false;
        return;
      }
      if (this.formData.deliveryTime === '0') {
        this.$message.error('样品的发货时间必须大于0');
        state = false;
        return;
      }
      if (!this.formData.mainImage) {
        this.$message.error('请选择主图片');
        state = false;
        return;
      }
      const { imgUrls, text } = this.$refs.textareaEditor.getHtml();
      if (imgUrls.length > 20) {
        this.$message.error('产品详情最多可以上传20张图片');
        state = false;
        return;
      }
      if (text.length > 5000) {
        this.$message.error('产品详情最多可以输入5000个字符');
        state = false;
        return;
      }
      return state;
    },
    saveBtn(val) {
      this.$refs.formData.validate(async valid => {
        if (valid) {
          if (this.checkParams()) {
            const { allHtml } = this.$refs.textareaEditor.getHtml();
            let params = { ...this.formData };
            params.information = allHtml.trim();
            // 产品功效
            params.odmProductEfficacyCmds = params.odmProductEfficacyCmds.map(
              item => {
                return {
                  productEfficacy: item,
                  odmId: params.id || '',
                };
              },
            );
            // 适合肤质
            params.odmSuitableSkinCmds = params.odmSuitableSkinCmds.map(
              item => {
                return {
                  suitableSkin: item,
                  odmId: params.id || '',
                };
              },
            );

            params.odmSuitableSkinCmds = params.odmSuitableSkinCmds.filter(item => item.suitableSkin);

            const $url = ['add', 'copy'].includes(this.status) ? 'createODMSample' : 'updateODMSample';
            if(['add', 'copy'].includes(this.status)) {
              delete params.id;
              delete params.sampleId;
            }

            try {
              const msg = await this.saveParams($url, params);
              // 提交
              if (val === 'submit') {
                this.$http.sampleManage
                  .batchSubmitSample([this.row.id])
                  .then(result => {
                    if (result.data.failNum > 0) {
                      this.$message.error(
                        result.data.failResultList[0].code +
                          result.data.failResultList[0].msg,
                      );
                    } else {
                      this.dialogVisible = true;
                    }
                  })
                  .catch(err => {
                    this.$message.error(err.msg);
                  })
                  .finally(() => {
                    this.saveLoading = false;
                  });
              } else {
                if (['add', 'copy', 'update'].includes(this.status)) {
                  this.$message.success(msg);
                  this.toSamplePage('submitSuccessToHistoryTab1');
                } else if (this.status === 'verify') {
                  // 审核
                  const params = {
                    ...this.$refs.verifyComponent.verifyFormData,
                  };
                  params.sampleId = this.row.id;
                  this.saveLoading = true;
                  this.$http.sampleManage
                    .createSampleCheck(params)
                    .then(result => {
                      this.$message.success(result.msg);
                      this.toSamplePage(
                        'toListTab1',
                        'sample-manage/verify-sample',
                        '审核样品',
                      );
                    })
                    .catch(err => {
                      this.$message.error(err.msg);
                    })
                    .finally(() => {
                      this.saveLoading = false;
                    });
                }
              }
            } catch (err) {
              this.$message.error(err);
            }
          }
        } else {
          this.$message.error('必填项不能为空，请认真检查哦！');
          this.pageScrollToTop();
          return false;
        }
      });
    },
    saveParams($url, params) {
      return new Promise((reslove, reject) => {
        this.saveLoading = true;
        this.$http.sampleManage[$url](params)
          .then(result => {
            // code=-1，错误提示
            if(result.data.code && result.data.code == -1) {
              reject(result.data.msg);
              return;
            }
            if (['add', 'copy'].includes(this.status)) {
              this.row.id = result.data;
            }
            reslove(result.msg);
          })
          .catch(err => {
            reject(err.msg);
          })
          .finally(() => {
            this.saveLoading = false;
          });
      });
    },
    resetForm() {
      this.showUploadImage = false;
      this.$nextTick(() => {
        this.showUploadImage = true;
      });
      this.status = 'add';
      this.statusName = '新增';
      this.row = { id: '' };
      this.$refs.formData.resetFields();
      this.formData.mainImage = '';
      this.$refs.textareaEditor.clear();
      const { code, name } = this.$store.getters.userSupplier;
      this.formData.supplierCode = code;
      this.formData.supplierName = name;
    },
    mainImageChange(val) {
      this.formData.mainImage = val;
      if (val) {
        this.$refs.formData.clearValidate('mainImage');
      } else {
        this.$refs.formData.validateField('mainImage');
      }
    },
    supplierChange(val, name) {
      this.formData.supplierCode = val;
      this.formData.supplierName = name;
    },
  },
};
</script>

<style lang="less" scoped>
.odmSuitableSkinCmdsClass {
  position: relative;
  .text-tips {
    position: absolute;
    left: 470px;
    top: 5px;
    p {
      line-height: 18px;
      font-size: 12px;
      color: #666;
    }
  }
}
</style>